export const STATUS_ACCEPTED = 'accepted';
export const STATUS_REJECTED = 'rejected';